import React from "react";
import Card from "../components/UI/Card";

const Algorithms = () => {
  return (
    <div className="row">
      <Card title="Sorting" link="/visualize/sorting" img="" desc="" />
      <Card title="Puzzle" link="/visualize/puzzle" img="" desc="" />
    </div>
  );
};

export default Algorithms;
